module.exports = __webpack_public_path__ + "static/media/prof-it.3990fa83.svg";